import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // checa se a rota é protegida.
    if (localStorage.token) {
      next();
    } else {
      next({ name: "login" });
    }
  }

  // checa se é guest.
  if (to.matched.some(record => record.meta.requiresGuest)) {
    if (localStorage.token) {
      next({ name: "Desafio" });
    } else {
      next();
    }
  }
  next();
});

export default router;
